import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import ResponseBlock_vue_vue_type_script_setup_true_lang_default from "./ResponseBlock.vue.script.js";
/* empty css                            */
//#region src/v2/blocks/response-block/ResponseBlock.vue
var ResponseBlock_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ResponseBlock_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-29000e66"]]);
//#endregion
export { ResponseBlock_default as default };

//# sourceMappingURL=ResponseBlock.vue.js.map